import React, { useState, useEffect, useContext } from 'react';

import ConfidentTerms from '../ConfidentTerms';
import B2BPortals from '../B2BPortals';
import NotFoundPage from '../NotFoundPage';
import LoadingPage from '../LoadingPage';
import RejectedPage from '../ConfidentTerms/RejectedPage';
import ShowB2BInfo from '../B2BPortals/B2BTable/ShowB2BInfo';

import { isvApi, API_URL } from '../../services/api';
import { fixCountries, INTERNATION_ISO2CODE, encryptData, decryptData, removePropFromObject } from '../../commons/utils';
import { contryListData, doNotFoundPortals } from '../../commons/testData';
import { ProductSelected } from '../../hooks/contexts';


const ClientNavigation = ({ match, setHasToReturn, setAccessToReturn, hasConfidentialityReturn }) => {
    const [isLoadingPage, setIsLoadingPage] = useState(true);
    const [clientData, setClientData] = useState();
    const [elementToRedirect, setElementToRedirect] = useState();

    const [isLoadingTermsButton, setIsLoadingTermsButton] = useState(false);
    const [errorRequestTermsPage, setIsErrorRequestTermsPage] = useState(false);

    const [selectedCountry, setSelectedCountry] = useState();
    const [countries, setCountries] = useState();
    const [isLoadingCountries, setIsLoadingCountries] = useState(false);

    const [isLoadingB2BSubmit, setIsLoadingB2BSubmit] = useState(false);
    const [isVisibleSuccessfullModal, seIsVisibleSuccessfullModal] = useState(false);

    const [portalInfoDataByCountry, setPortalInfoDataByCountry] = useState();
    const [isLoadingPortalInfoDataByCountry, setIsLoadingPortalInfoDataByCountry] = useState(false);
    const [isErrorB2BAddRequest, setIsErrorB2BAddRequest] = useState(false);
    const [isClickedAddB2BManual, setIsClickedAddB2BManual] = useState(false)
    const {productsStatus} = useContext(ProductSelected);

    const handleClickTerms = (accept) => {
        setIsLoadingTermsButton(true);
        setIsErrorRequestTermsPage(false);

        isvApi.post(`${API_URL.acceptTerms}?hash=${match.params.hashCode}`, { accept })
            .then(() => {
                setClientData({
                    ...clientData,
                    accepted: accept,
                });
                if (accept) {
                    setElementToRedirect("b2bPortals");
                } else {
                    setElementToRedirect("rejectedPage");
                }
            })
            .catch(() => setIsErrorRequestTermsPage(true))
            .finally(() => setIsLoadingTermsButton(false))
    };

    useEffect(() => {
        if (!portalInfoDataByCountry && selectedCountry) {
            setIsLoadingPortalInfoDataByCountry(true);
            const iso2Code = selectedCountry.iso2_code === INTERNATION_ISO2CODE ? 'CL' : selectedCountry.iso2_code;
            isvApi.get(`${API_URL.portalInfo}?iso2_code=${iso2Code}&exclude_type_week=1`)
                .then(response => {
                    const portals = response.data.map(p => ({
                        ...p,
                        is_b2b_manual: false,
                        userType: null,
                    }))

                    setPortalInfoDataByCountry(portals);
                })
                .catch(() => {
                    setPortalInfoDataByCountry(doNotFoundPortals);
                })
                .finally(() => setIsLoadingPortalInfoDataByCountry(false));
        }
    }, [selectedCountry, portalInfoDataByCountry]);

    useEffect(() => {
        if (!countries) {
            setIsLoadingCountries(true);
            isvApi.get(API_URL.contries)
                .then(response => {
                    setCountries(fixCountries(response.data));
                })
                .catch(() => {
                    setCountries(contryListData);
                })
                .finally(() => setIsLoadingCountries(false));
        }
    }, [countries]);

    useEffect(() => {
        if (!selectedCountry && clientData && countries) {
            const country = countries.find((c) => c.iso2_code === clientData.personal_data.country);
            setSelectedCountry(country);
        }
    }, [clientData, countries, selectedCountry]);

    useEffect(() => {
        if (hasConfidentialityReturn) {
            setElementToRedirect("confidentTerms");
        } else if (!clientData) {
            isvApi.get(`${API_URL.getClientData}?hash=${match.params.hashCode}`)
                .then((response) => {
                    const responseData = {
                        ...response.data,
                        b2b_table: response.data.b2b_table.map((b2b) => ({
                            ...b2b,
                            password: decryptData(b2b.password, match.params.hashCode),
                        })),
                    };
                    setClientData(responseData);
                    if (responseData.completed) {
                        setElementToRedirect("completedB2B");
                    } else {
                        switch (responseData.accepted) {
                        case true:
                            setElementToRedirect("b2bPortals");
                            break;
                        case false:
                            setElementToRedirect("rejectedPage")
                            break;
                        default:
                            setElementToRedirect("confidentTerms");
                            break;
                        }
                    }
                })
                .catch((error) => {
                    setElementToRedirect("notFoundPage")
                })
                .finally(() => setIsLoadingPage(false));
        }
    }, [isLoadingPage, clientData, match.params.hashCode, hasConfidentialityReturn]);

    const handleChangePortal = (portal, index) => {
        const b2bTableDataCopied = [...clientData.b2b_table];
        b2bTableDataCopied[index] = {
            ...b2bTableDataCopied[index],
            portal,
            portal_link: (portal || {}).portal_link || '',
        };
        setClientData({ ...clientData, b2b_table: b2bTableDataCopied });
    };

    const handleChangePortalLink = (portaLink, index) => {
        const b2bTableDataCopied = [...clientData.b2b_table];
        b2bTableDataCopied[index] = {
            ...b2bTableDataCopied[index],
            portal_link: portaLink,
        };
        setClientData({ ...clientData, b2b_table: b2bTableDataCopied });
    };

    const handleChangeUserTypeWalmart = (portal, index) => {
        const b2bTableDataCopied = [...clientData.b2b_table];
        b2bTableDataCopied[index] = {
            ...portal,
        };
        setClientData({ ...clientData, b2b_table: b2bTableDataCopied });
    }

    const removeLastB2BRowTable = () => {
        const b2bTableDataCopied = [...clientData.b2b_table];
        b2bTableDataCopied.pop();
        setClientData({ ...clientData, b2b_table: b2bTableDataCopied });
    };

    const handleClickOKModal = () => handleClickCloseModal();

    const handleClickCancelModal = () => seIsVisibleSuccessfullModal(false);

    const encryptB2BPasswords = (b2bData) => b2bData.map((b2b) => ({
        ...b2b,
        portal: removePropFromObject(b2b.portal, 'portal_description'),
        password: encryptData(b2b.password, match.params.hashCode),
    }));

    const handleClickAddB2B = (b2bData, completed, openModal = false, addB2BManual = false) => {
        setIsLoadingB2BSubmit(true);

        if (addB2BManual && b2bData.length === 1 && !b2bData[0].username) {
            b2bData[0].username = "fake-temp"
        }

        const { personal_data } = clientData;

        const shallowB2BData = JSON.parse(JSON.stringify(b2bData))

        shallowB2BData.map((dataPortal) => {
            if (dataPortal.portal.userType === "symantec") {
                dataPortal.rut = JSON.stringify(dataPortal.rut);
            }
            dataPortal.portal.user_type = dataPortal.portal.userType;
            delete dataPortal.portal.userType;
        })

        const requestData = {
            completed,
            b2b_data: encryptB2BPasswords(shallowB2BData),
            personal_data: {
                ...personal_data,
                prefix: personal_data.prefix.toLowerCase().replaceAll(' ','_'),
                ...productsStatus,
            },
        };

        setIsErrorB2BAddRequest(false);

        delete requestData.personal_data.isIsv;
        delete requestData.personal_data.isMks;
        delete requestData.personal_data.isSupplai;
        delete requestData.personal_data.isTc;

        isvApi.post(`${API_URL.clientPortals}?hash=${match.params.hashCode}`, requestData)
            .then(() => {
                let b2bTableData = b2bData;
                if (!openModal) {
                    if (b2bData.length === 1 && b2bData[0].portal.is_b2b_manual && !b2bData[0].portal.portal_link) {
                        if (b2bData[0].username === "fake-temp") {
                            b2bData[0].username = ""
                        }

                        b2bTableData = [...b2bTableData]
                    } else {
                        let shadowObj = {
                            category: "",
                            password: "",
                            rut: "",
                            username: "",
                        }

                        if (addB2BManual) {
                            shadowObj["portal"] = {
                                is_b2b_manual: true,
                                required_fields: [
                                    "username",
                                    "rut",
                                ]
                            }
                        }

                        b2bTableData = [...b2bTableData, shadowObj]
                    }
                } else {
                    seIsVisibleSuccessfullModal(true);
                }

                setClientData({
                    ...clientData,
                    b2b_table: b2bTableData,
                });
            })
            .catch(() => {
                setIsErrorB2BAddRequest(true);
            })
            .finally(() => setIsLoadingB2BSubmit(false))

        if (addB2BManual) {
            setIsClickedAddB2BManual(true)
        } else {
            setIsClickedAddB2BManual(false)
        }
    };

    const handleClickCloseModal = () => {
        seIsVisibleSuccessfullModal(false);
        setClientData({
            ...clientData,
            completed: true,
        });
        setElementToRedirect("completedB2B");
    };

    if (isLoadingPage || isLoadingCountries || isLoadingPortalInfoDataByCountry) {
        setHasToReturn(false);
        return <LoadingPage />
    } else if (elementToRedirect) {
        setHasToReturn(true);
        switch (elementToRedirect) {
        case "notFoundPage":
            return <NotFoundPage />;
        case "rejectedPage":
            return <RejectedPage />;
        case "confidentTerms":
            setAccessToReturn(false);
            return <ConfidentTerms
                clientPersonalData={clientData.personal_data}
                handleClickTerms={handleClickTerms}
                isLoadingTermsButton={isLoadingTermsButton}
                errorRequestTermsPage={errorRequestTermsPage}
            />
        case "b2bPortals":
            setHasToReturn(null);
            return <B2BPortals
                clientData={clientData}
                selectedCountry={selectedCountry}
                handleClickAddB2B={handleClickAddB2B}
                isLoadingSubmit={isLoadingB2BSubmit}
                isVisibleSuccessfullModal={isVisibleSuccessfullModal}
                portalInfoData={portalInfoDataByCountry}
                handleChangePortal={handleChangePortal}
                handleChangePortalLink={handleChangePortalLink}
                handleClickOKModal={handleClickOKModal}
                handleClickCancelModal={handleClickCancelModal}
                isErrorB2BAddRequest={isErrorB2BAddRequest}
                removeLastB2BRowTable={removeLastB2BRowTable}
                isClickedAddB2BManual={isClickedAddB2BManual}
                handleChangeUserTypeWalmart={handleChangeUserTypeWalmart}
            />
        case "completedB2B":
            return <ShowB2BInfo clientData={clientData} selectedCountry={selectedCountry} />
        default:
            return <NotFoundPage />;
        }
    }
};

export default ClientNavigation;
